import { Link, Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { NBSP } from '~/common/constants';
import { I18nNamespace } from '~/common/types';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom/DataGridCustom.types';
import { RouteId } from '~/routes';

export type ProcessedByCellValue = { caseId: string; caseSequenceNumber: string } | null | undefined;

interface ProcessedByCellProps<R extends GridValidRowModel = any> {
  value: ProcessedByCellValue;
  row: R;
}

export const ProcessedByCell = <R extends GridValidRowModel = any>({ value }: ProcessedByCellProps<R>) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'DemandAwardingWidget.cell.processedBy' });
  if (value) {
    return (
      <>
        <span>{t('label')}</span>
        {NBSP}
        <Typography
          component="div"
          variant="caption"
          noWrap
          sx={{
            color: 'text.secondary',
          }}
        >
          ({t('case')}
          {NBSP}
          <Link component={RouterLink} color="inherit" to={RouteId.negotiationDetail(value.caseId)}>
            {value.caseSequenceNumber}
          </Link>
          )
        </Typography>
      </>
    );
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
